<div class="flex flex-col h-full min-h-0 py-2">
  <p class="text-sm text-muted-color mb-3 shrink-0">
    Choose a template to pre-fill the item structure
    @if (showSkip) {
      , or click
      <strong>Skip</strong> to generate items directly from the uploaded CAD
      hierarchy
    }
    .
  </p>
  <div class="flex-1 min-h-0 overflow-y-auto">
    <app-blueprints-selector
      [selectedBlueprintId]="selectedBlueprint()?.id || null"
      [blueprints]="allBlueprints"
      (blueprintSelected)="onBlueprintSelection($event)"
    />
  </div>
  <div class="flex justify-between gap-2 mt-4 shrink-0">
    <p-button label="Back" severity="secondary" (onClick)="onBack()" />
    <div class="flex gap-2">
      @if (showSkip) {
        <p-button
          label="Skip"
          severity="secondary"
          icon="pi pi-arrow-right"
          iconPos="right"
          (onClick)="skip.emit()"
          pTooltip="Build items directly from the CAD hierarchy without a template"
          tooltipPosition="top"
        />
      }
      <p-button
        [label]="nextLabel"
        [icon]="nextIcon"
        iconPos="right"
        (onClick)="next.emit()"
        [disabled]="!selectedBlueprint()"
      />
    </div>
  </div>
</div>
